<template>
  <div class="testwrap">
    <img v-for="(item, index) in list" :key="index" :src="item" alt="" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.r && this.$route.query.r == 1) {
        this.list = ['https://ui.smartrecorder.xyz/ad/registerTips.png'];
      } else {
        let inx = this.$route.query.index;
        this.list = this.$store.state.app.adBanner.viewList[inx];
      }
    },
  },
};
</script>
<style scoped>
.testwrap img {
  display: block;
  width: 100%;
}
</style>
